<template>
  <div class="q_tabs_btn_wrapper">
    <div
      class="q_tabs_btn_inner_box"
      @mouseenter="handleInterval('enter')"
      @mouseleave="handleInterval('leave')"
    >
      <div
        v-for="(item, index) in configArr"
        :key="index"
        class="q_tabs_btn"
        :class="props.activeVal === item.value ? 'q_tabs_btn_active' : ''"
        @click="handleTabChange(item.value, index)"
      >
        <div class="q_tabs_btn_text">
          {{ item.label }}
        </div>
        <!-- 占位符，不设定按钮固定宽度 -->
        <div class="q_tabs_btn_text_opacity">
          {{ item.label }}
        </div>
      </div>
      <div
        v-if="maskStyle"
        class="q_tabs_btn_active_mask"
        :style="maskStyle"
      ></div>
    </div>
  </div>
</template>

<script>
import { ref, watch, nextTick, onMounted } from 'vue';

const DEFAULTCONFIG = [
  {
    label: '默认1',
    value: 1
  },
  {
    label: '默认1',
    value: 2
  }
];
export default {
  props: {
    config: String,
    activeVal: String,
    autoChange: Boolean,
    counter: Number
  },
  setup(props, vm) {
    let timer = null;
    const activeVal = ref(props.activeVal || DEFAULTCONFIG[0]);
    const autoChange = ref(props.autoChange || false);
    const activeIndex = ref(0);
    const maskStyle = ref(null);
    const configArr = ref(DEFAULTCONFIG);
    const mouseType = ref(null);
    const handleTabChange = (val, index) => {
      activeVal.value = val;
      activeIndex.value = index;
      vm.emit('onChange', val);
    };
    const updateMaskStyle = async () => {
      await nextTick();
      const dom = document.querySelectorAll('.q_tabs_btn')[activeIndex.value];
      if (dom) {
        maskStyle.value = {
          width: `${dom.clientWidth}px`,
          left: `${dom.offsetLeft}px`
        };
      }
    };
    const handleInterval = (type) => {
      if (autoChange.value === true) {
        mouseType.value = type;
        if (type === 'enter') {
          clearInterval(timer);
        } else {
          if (props.counter === 0 && !timer) {
            initSetInterval();
          }
        }
      }
    };
    const initSetInterval = () => {
      timer = setInterval(() => {
        activeVal.value = activeVal.value === configArr.value[0].value ? configArr.value[1].value : configArr.value[0].value;
        activeIndex.value = activeVal.value === configArr.value[0].value ? 0 : 1;
        vm.emit('onChange', activeVal.value);
        updateMaskStyle();
      }, 5000);
    };
    onMounted(() => {
      if (autoChange.value === true) {
        initSetInterval();
      }
    });
    const init = () => {
      if (props.config) {
        configArr.value = [...props.config];
      }
    };
    watch(() => activeIndex.value, () => {
      updateMaskStyle();
    });
    watch(() => props.counter, () => {
      if (mouseType.value === 'leave' && props.counter === 0) {
        initSetInterval();
        mouseType.value = null;
      }
    });

    init();
    updateMaskStyle();
    return {
      handleTabChange,
      handleInterval,
      DEFAULTCONFIG,
      props,
      maskStyle,
      activeIndex,
      configArr
    };

  }
}
</script>

<style  lang="less" scoped>
.q_tabs_btn_wrapper {
  display: flex;
  padding: 4px;
  align-items: flex-start;
  gap: 4px;
  border-radius: 6px;
  border: 1px solid var(---, rgba(255, 255, 255, 0.12));
  background: rgba(17, 21, 30, 0.9);
  .q_tabs_btn_inner_box {
    display: flex;
    position: relative;
    gap: 4px;
    .q_tabs_btn {
      //   min-width: 72px;
      //   height: 28px;
      padding: 4px 8px;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      transition: all 0.3s;
      text-align: center;
      overflow: hidden;
      cursor: pointer;
    }

    .q_tabs_btn_text_opacity {
      line-height: 20px; /* 142.857% */
      opacity: 0;
    }

    .q_tabs_btn_text {
      color: var(--LPZ-, #eaedff);
      /* 14px */
      font-family: 'PingFang SC';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      transition: all 0.3s;
      position: absolute;
      z-index: 10;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }

    .q_tabs_btn_active {
      position: relative;

      .q_tabs_btn_text {
        font-family: 'PingFang SC';
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 142.857% */
        background: var(--applicationSafeDataHigh);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        cursor: default;
      }
    }

    .q_tabs_btn_active_mask {
      height: 100%;
      display: flex;
      border-radius: 4px;
      background-color: #234d66;
      position: absolute;
      top: 0;
      z-index: 9;
      transition: all 0.3s;
    }
  }
}
// .q_tabs_btn_wrapper {
//   display: flex;
//   padding: 4px;
//   align-items: flex-start;
//   gap: 4px;
//   border-radius: 6px;
//   border: 1px solid var(---, rgba(255, 255, 255, 0.12));
//   background: rgba(17, 21, 30, 0.9);
// }
// .q_tabs_btn_inner_box {
//   position: relative;
//   display: flex;
// }
// .q_tabs_btn {
//   position: relative;
//   cursor: pointer;
// }
// .q_tabs_btn_text {
//   color: var(--LPZ-, #eaedff);

//   /* 14px */
//   font-family: 'PingFang SC';
//   font-size: 14px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: 20px; /* 142.857% */
//   display: flex;
//   padding: 4px 8px;
//   justify-content: center;
//   align-items: center;
//   gap: 10px;
//   opacity: 0.5;
// }
// .q_tabs_btn_text_opacity {
//   opacity: 0;
//   position: absolute;
//   top: 0;
//   left: 0;
//   font-family: 'PingFang SC';
//   font-size: 14px;
//   font-style: normal;
//   font-weight: 400;
//   line-height: 20px; /* 142.857% */
//   display: flex;
//   padding: 4px 8px;
//   justify-content: center;
//   align-items: center;
//   gap: 10px;
// }
// .q_tabs_btn_active {
//   font-family: 'PingFang SC';
//   font-size: 14px;
//   font-style: normal;
//   font-weight: 600;
//   line-height: 20px; /* 142.857% */
//   background: var(--applicationSafeDataHigh);
//   background-clip: text;
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
// }
// .q_tabs_btn_active_mask {
//   position: absolute;
//   height: 100%;
//   border-radius: 4px;
//   transition: all 0.3s ease;
//   z-index: -1;
//   border-radius: 6px;
//   border: 1px solid var(---, rgba(255, 255, 255, 0.12));
//   background: rgba(17, 21, 30, 0.9);
// }
</style>